import { useState } from "react";
import Table from "../../components/Table/Table";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetJourneysQuery } from "../../store/services/journey-service";

export default function JourneyTable() {
    const navigate = useNavigate();

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 20,
        page: 0,
    });

    const [serverSearchQuery, setServerSearchQuery] = useState("");

    const queryParams = {
        perPage: paginationModel.pageSize,
        page: paginationModel.page,
        includes: "",
        query: "",
        searchTerm: serverSearchQuery,
        additionalQueryParams: ""
    };

    const { data: journeysData, isLoading: journeysLoading, error: journeysError } = useGetJourneysQuery(queryParams);

    const [selected, setSelected] = useState([]);

    const handleViewJourney = (journey) => {
        navigate(`/journeys/${journey.id}`);
    };

    const headCells = [
        {
            id: "view",
            label: "View",
            initialVisible: true,
            render: (journey) => (
                <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    onClick={() => handleViewJourney(journey)}
                >
                    View
                </Button>
            ),
        },
        { id: "id", label: "ID", initialVisible: true },
        { id: "name", label: "Journey Name", initialVisible: true }
    ];

    return (
        <Table
            name={"Journeys"}
            data={journeysData?.data}
            count={journeysData?.rowsAffected}
            error={journeysError}
            loading={journeysLoading}
            headCells={headCells}
            search={true}
            editColumn={false}
            checkbox={false}
            showToolbarActions={false}
            onDelete={() => {}}
            onCellClick={handleViewJourney}
            selected={selected}
            setSelected={setSelected}
            initialVisibleColumns={headCells.filter(cell => cell.initialVisible).map(cell => cell.label)}
            maxTableHeight={"calc(100vh - 250px)"}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            isServerSidePagination={true}
            serverSearchQuery={serverSearchQuery}
            setServerSearchQuery={setServerSearchQuery}
        />
    );
}
